<div [ngClass]="container.value == value ? 'content expanded' : 'content collapsed'">
    <ng-content></ng-content>
</div>
